"use client"

import { useEffect, useRef } from "react"
import { useSearchParams } from "next/navigation"
import { TurkwiseLoader } from "@turkwise/design-system"
import { startAuth0Login } from "@/lib/auth/client"
import { resolveLoginContinuation } from "@/lib/auth/loginContinuation"
import { AuthLayout } from "../components/AuthLayout"
import { AccountLoginRecovery } from "./AccountLoginRecovery"

export default function LoginPage() {
  const searchParams = useSearchParams()
  const authError = searchParams.get("authError")
  const returnTo = resolveLoginContinuation(searchParams.get("redirectTo") ?? "/console/home")
  const started = useRef(false)

  const login = () => {
    startAuth0Login({ returnTo, prompt: "login" })
  }

  useEffect(() => {
    if (authError || started.current) return
    started.current = true
    login()
  // The URL parameters are the immutable input for this redirect attempt.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AuthLayout
      titleKey="auth.welcome"
      subtitleKey="auth.welcomeMessage"
      footerTextKey="auth.dontHaveAccount"
      footerLink={{ textKey: "auth.register", href: "/register" }}
    >
      <div className="twds-auth-form" data-testid="auth0-login-handoff">
        {authError ? <AccountLoginRecovery code={authError} returnTo={returnTo} onRetry={login} /> : <div className="twds-auth-form__status" role="status"><div className="twds-auth-form__status-content"><TurkwiseLoader /><span>Güvenli TurkWise SSO ekranına yönlendiriliyorsunuz…</span></div></div>}
      </div>
    </AuthLayout>
  )
}
